// extracted by mini-css-extract-plugin
module.exports =  {"overrideGap":"hy_5jzemkvcxFLKURgAK"};